import React from "react";

const YurticiOrgCont = () => {
  return (
    <div className="">
      <section className="">
        <div className="py-12 bg-white ">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="lg:text-center">
              <h2 className="font-heading mb-4 bg-orange-100 px-4 py-2 rounded-lg md:w-64 md:mx-auto text-xs font-semibold tracking-widest text-black uppercase title-font">
                Neden Bizi Seçmelisiniz?
              </h2>
              <p className="font-heading mt-2 text-3xl leading-8 font-bold tracking-tight text-gray-900 sm:text-4xl">
                Yurt İçi Organizasyonlar
              </p>
              <p className="mt-4 max-w-2xl text-lg text-gray-500 lg:mx-auto">
                Kişisel ya da grup olarak aklınızdan geçirdiğiniz her türlü
                organizasyonda biz yanınızdayız. Türkiye'nin dört bir yanını
                kapsayan lokasyon bilgimiz ve her türden toplantıların yönetimi
                konusundaki deneyimimizle sizinleyiz. Boyutu ve kişi sayısı hiç
                önemli değil.Türkiye'de katılmak ya da düzenlemek istediğiniz
                aktivitelerinizi planlıyor ve uyguluyoruz.
              </p>
            </div>
            <div className="mt-10">
              <dl className="space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-10">
                <div className="relative">
                  <dt>
                    <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-primary-500 text-white">
                      <img src="https://www.svgrepo.com/show/451394/tour-pin-tear.svg" />
                    </div>
                    <p className="font-heading ml-16 text-lg leading-6 font-bold text-gray-600">
                      Yurt İçi Teşvik Ve Bayi Gezileri
                    </p>
                  </dt>
                  <dd className="mt-2 ml-16 text-base text-gray-500">
                    Deneyimli kadrosu ve bilgi birikimi ile Türkiye’nin her
                    köşesinde gerçekleştirdiği başarılı organizasyonlar, Jojo
                    Turizm’i teşvik ve bayi gezilerinde Türkiye’nin önde gelen
                    kuruluşlarına hizmet veren, sektöründe ilkleri
                    gerçekleştiren, öncü bir çözüm ortağı durumuna getirdi.
                    Amacınız isterseniz bir dağın zirvesindeki enerji tesisini
                    tanıtmak, isterseniz şehrin göbeğindeki beş yıldızlı bir
                    otelde konferanslarınızı düzenlemek ve istediğiniz dilde
                    simultane tercümesini yaptırmak ya da çalışanlarınızı bir
                    piknikte buluşturup çoluk çocuk eğlendirmek olsun, her
                    ortamda sizlerle birlikte olmaya hazırız.
                  </dd>
                </div>
                <div className="relative">
                  <dt>
                    <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-primary-500 text-white">
                      <img src="https://www.svgrepo.com/show/529463/chair-2.svg" />
                    </div>
                    <p className="font-heading ml-16 text-lg leading-6 font-bold text-gray-600">
                      Yurt İçi Toplantı, Kongre Ve Seminer Hizmetleri
                    </p>
                  </dt>
                  <dd className="mt-2 ml-16 text-base text-gray-500">
                    {" "}
                    Türkiye, toplantı kongre ve seminer hizmetleri açısından
                    artan bir ivme ile ilerliyor. Yurt içindeki tesis altyapısı
                    bu ivmeye büyük katkı sağlıyor ve Jojo Turizm bu gelişimi ve
                    değişikliği sizin adınıza en yakından takip ediyor.
                    Toplantı, kongre ve seminer katılımı veya
                    organizasyonlarınızda ürün bilgimiz, rekabetçi fiyatlarımız
                    ve tecrübeli personelimizin farkını sizlerle paylaşıyoruz.
                    Yüksek katılımlı dönem toplantıları konusunda iddialıyız.
                    Müşterilerimizle aramızdaki ticari ilişkiyi, açık kitap
                    usulü paylaşarak çalışma modelini tercih ediyor; kazancımızı
                    beraber belirlemek istiyoruz.
                  </dd>
                </div>
                <div className="relative">
                  <dt>
                    <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-primary-500 text-white">
                      <img src="https://www.svgrepo.com/show/501237/invitation.svg" />
                    </div>
                    <p className="font-heading ml-16 text-lg leading-6 font-bold text-gray-600">
                      Yurt İçi Ürün Lansmanları, Açılış, Davet & Fuar Hizmetleri
                    </p>
                  </dt>
                  <dd className="mt-2 ml-16 text-base text-gray-500">
                    {" "}
                    Zirveye doğru yürürken bazı duraklarda durup hem bir soluk
                    alır hem de gerekli toplantılar yaparsınız. Yeni bir ürün
                    çıkarırsınız örneğin; lansmanını yapmak gerekir. Ya da yeni
                    bir birim kurarsınız, ardından açılış gelir. Davetti fuardı
                    derken iş yükünüz büyür. Uğraşılması gereken kalemler artar.
                    Ya da tüm bunların yakınlarda gerçekleşeceğini öngörür,
                    bizlere ulaşırsınız. Tüm bu yük omuzlarınızdan usulca kayar
                    gider.
                  </dd>
                </div>
                <div className="relative">
                  <dt>
                    <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-primary-500 text-white">
                      <img src="https://www.svgrepo.com/show/24954/concert.svg" />
                    </div>
                    <p className="font-heading ml-16 text-lg leading-6 font-bold text-gray-600">
                      Yurt İçi Konser, Spor Organizasyonları & Basın Gezileri
                    </p>
                  </dt>
                  <dd className="mt-2 ml-16 text-base text-gray-500">
                    {" "}
                    Müşterileriniz, çalışanlarınız veya hedef kitleniz için
                    konser ya da spor organizasyonları düzenlemek veya bu
                    organizasyonlara birlikte katılmak ister misiniz? Firmanız
                    adına ülkemize getireceğimiz dünyaca ünlü bir sanatçıyı,
                    sporcuyu, grubu veya organizasyonu en ön sırada
                    müşterilerinizle beraber izlemek hoşunuza gitmez mi? Basın
                    mensuplarıyla aranız nasıl? Sizi ve yaptıklarınızı ne kadar
                    biliyorlar? Onları bir basın gezisinde bir araya getirip,
                    kurumunuzu bu ortamda tanıtmaya ne dersiniz?
                  </dd>
                </div>
              </dl>
            </div>
            <div className="mt-10">
              <dl className="space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-10">
                <div className="relative">
                  <dt>
                    <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-primary-500 text-white">
                      <img src="https://www.svgrepo.com/show/533406/book.svg" />
                    </div>
                    <p className="font-heading ml-16 text-lg leading-6 font-bold text-gray-600">
                      Yurt İçi Eğitim Seminerleri
                    </p>
                  </dt>
                  <dd className="mt-2 ml-16 text-base text-gray-500">
                    {" "}
                    Kurumunuz için arzu ettiğiniz hedef kitleye düzenleyeceğiniz
                    eğitim organizasyonlarında tecrübeliyiz. Bütçeleme ile
                    başlayan; yer seçimi, teknik altyapı, ikramlar gibi ana
                    hatların yanı sıra, katılımcıların dikkatlerinin eğitim
                    süresi boyunca nasıl çekilebileceği gibi stratejik
                    detaylarla devam eden bütün süreçler boyunca
                    müşterilerimizin yanındayız.
                  </dd>
                </div>
                <div className="relative">
                  <dt>
                    <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-primary-500 text-white">
                      <img src="https://www.svgrepo.com/show/489938/vip.svg" />
                    </div>
                    <p className="font-heading ml-16 text-lg leading-6 font-bold text-gray-600">
                      Incoming Hizmetleri
                    </p>
                  </dt>
                  <dd className="mt-2 ml-16 text-base text-gray-500">
                    {" "}
                    Çokuluslu şirket müşterilerimizin son yıllardaki birçok
                    toplantısına ülkemiz ev sahipliği yapıyor. Müşterilerimizle
                    birlikte dünyanın birçok ülkesinden gelen profesyonel iş
                    ortak ve arkadaşlarına ev sahipliği yapmak konusunda
                    uzmanız. Gelen kişilerin profiline, ziyaret amaçlarına ve
                    müşterimizin bütçesine en uygun alternatifleri sunuyoruz.
                    VIP karşılamalar, hizmetler ve öğrenci gruplarına verdiğimiz
                    akademik içerikli organizasyonların yanı sıra yurt dışından
                    gelen basının ev sahipliğini de biz yapıyoruz. Bununla
                    bitmiyor, uluslararası iş ortaklarımızdan gelen tüm
                    Türkiye’deki yerel hizmetleri ve münferit turları da keyifle
                    organize ediyoruz.
                  </dd>
                </div>
              </dl>
            </div>
          </div>
        </div>
      </section>
      <>
        {/* Container for demo purpose */}
        <div className="container my-24 mx-auto md:px-6">
          {/* Section: Design Block */}
          <section className="mb-32 m-10">
            {/* Comment */}
            <div className="mb-12 flex flex-wrap md:mb-0">
              <div className="w-full md:w-2/12 shrink-0 grow-0 basis-auto">
                <img
                  src="https://estetiksacekimidiamonds.com/wp-content/uploads/otel-rezervasyon.jpg"
                  className="mb-6 w-full rounded-lg shadow-lg dark:shadow-black/20"
                  alt="Avatar"
                />
              </div>
              <div className="w-full md:w-10/12 shrink-0 grow-0 basis-auto md:pl-6">
                <p className="mb-3 text-2xl font-semibold">
                  Yurt İçi Rezervasyon Hizmetleri
                </p>
                <p>
                  Kurumsal ve münferit müşterilerimizin yurt içindeki otel
                  transfer, araç kiralama organizasyonlarını rekabetçi
                  fiyatları, sektör bilgimiz ve tecrübeli personelimizle seyahat
                  politikanıza uygun biçimde gerçekleştiriyoruz. Online
                  mutabakat ve raporlama hizmetleri sunuyoruz.
                </p>
              </div>
            </div>
          </section>
        </div>
      </>
    </div>
  );
};

export default YurticiOrgCont;
